module.exports = __webpack_public_path__ + "static/media/icon_154.63e7a483.svg";